"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _styling = require("../../../toolkit/styling");

var _device = require("../../../toolkit/device");

var _class, _class2, _descriptor, _descriptor2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var StaggeredScaleIn = (0, _mobxReact.observer)(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(StaggeredScaleIn, _Component);

  var _super = _createSuper(StaggeredScaleIn);

  function StaggeredScaleIn() {
    var _this;

    (0, _classCallCheck2["default"])(this, StaggeredScaleIn);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _initializerDefineProperty2["default"])(_this, "animationEnd", _descriptor, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "handleAnimationEnd", _descriptor2, (0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(StaggeredScaleIn, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          animationDurationMs = _this$props.animationDurationMs,
          animationDelayMs = _this$props.animationDelayMs,
          startScale = _this$props.startScale,
          children = _this$props.children,
          className = _this$props.className,
          props = (0, _objectWithoutProperties2["default"])(_this$props, ["animationDurationMs", "animationDelayMs", "startScale", "children", "className"]);
      return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, {
        onAnimationEnd: this.handleAnimationEnd,
        className: (0, _styling.css)(this.styles.root, className)
      }), children);
    }
  }, {
    key: "numChildren",
    get: function get() {
      var children = this.props.children;
      return _react["default"].Children.count(children);
    }
  }, {
    key: "styles",
    get: function get() {
      var _this$props2 = this.props,
          animationDelayMs = _this$props2.animationDelayMs,
          _this$props2$startSca = _this$props2.startScale,
          startScale = _this$props2$startSca === void 0 ? 0 : _this$props2$startSca,
          _this$props2$animatio = _this$props2.animationDurationMs,
          animationDurationMs = _this$props2$animatio === void 0 ? 1000 : _this$props2$animatio;
      var keyframes = {
        from: {
          transform: "scale(".concat(startScale, ", ").concat(startScale, ", ").concat(startScale, ")"),
          opacity: 0.5
        },
        to: {
          transform: "scale3d(1, 1, 1)",
          opacity: 1
        }
      };
      var staggers = {};
      var stepSize = animationDurationMs / this.numChildren; // eslint-disable-next-line local-rules/no-c-style-for-loop

      for (var i = 1; i <= this.numChildren; i++) {
        staggers[":nth-child(".concat(i, ")")] = {
          animationDuration: "".concat(100 + i * stepSize, "ms")
        };
      }

      var _DeviceStore$instance = _device.DeviceStore.instance(),
          isFirefox = _DeviceStore$instance.isFirefox;

      return _aphrodite.StyleSheet.create({
        root: !this.animationEnd ? {
          ":nth-child(1n) > *": _objectSpread({
            animationName: [keyframes],
            transform: isFirefox ? undefined : "scale3d(0, 0, 0)",
            transformOrigin: "center",
            animationFillMode: "forwards",
            animationDelay: animationDelayMs && "".concat(animationDelayMs, "ms")
          }, staggers)
        } : {}
      });
    }
  }]);
  return StaggeredScaleIn;
}(_react.Component), _temp), (_descriptor = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "animationEnd", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "numChildren", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "numChildren"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "handleAnimationEnd", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function () {
      _this2.animationEnd = true;
    };
  }
})), _class2)) || _class;

var _default = StaggeredScaleIn;
exports["default"] = _default;